export function getGreeting(date = new Date()): { salutation: string; italicWord: string } {
  const h = date.getHours()
  if (h < 11) return { salutation: 'Good', italicWord: 'morning' }
  if (h < 17) return { salutation: 'Good', italicWord: 'afternoon' }
  if (h < 22) return { salutation: 'Good', italicWord: 'evening' }
  return { salutation: 'Hello', italicWord: '' }
}
